export default __webpack_public_path__ + "static/media/rm-health-app.232b324f.png";